class Utils {
    public static makeid(length: number) {
        const count = length - 1;
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < count; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }
}

export {Utils}


// WEBPACK FOOTER //
// ./app/helpers/utils.ts